<template>
  <div class="site-wrapper site-page--login">
    <div></div>
    <div class="site-content__wrapper">
      <div class="mid-content1">
        <!-- 左侧透明 -->
        <div class="login-left">
          <div class="img">
            <img src="@/assets/img/login.png" alt />
          </div>
          <div class="en">WELCOME</div>
        </div>
        <!-- 右侧登录 -->
        <div class="login-main">
          <div style="margin-top:100px;margin-bottom:50px;font-size:xx-large" >用户登录</div>
          <el-form
            :model="dataForm"
            :rules="dataRule"
            ref="dataForm"
            @keyup.enter.native="dataFormSubmit()"
            status-icon
            style="margin-top:-10px"
          >
           <el-form-item prop="mobile">
            <el-input
              v-model="dataForm.mobile"
              placeholder="请输入电话号码"
             style="width:518px;margin-top:20px;height:49px;line-height:49px"
              prefix-icon="el-icon-phone"
            >
            </el-input>
          </el-form-item>
            <el-form-item prop="password">
            <el-input
              v-model="dataForm.password"
              placeholder="请输入验证码"
              prefix-icon="el-icon-message"
              style="width:518px;height:49px;line-height:49px"
            >
              <template #suffix>
                  <div v-if="messageCodeVis" class="second-text">
                    {{countdown}}秒后重新获取
                  </div>
                  <el-button v-else type="text" link @click="sendCode()">
                    获取验证码
                  </el-button>
              </template>
            </el-input>
          </el-form-item>
            <el-form-item>
              <el-button
                style="width:518px;margin-top:10px;background: #2c8cf0;border-radius: 4px;border-radius: 4px;height:49px"
                class="login-btn-submit"
                type="primary"
                @click="dataFormSubmit()"
              >登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        mobile: "",
        password: "",
      },
      messageCodeVis: false,
      countdown: 60,
      dataRule: {
        mobile: [
          { required: true, message: "电话号码不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "登录密码不能为空", trigger: "submit" }
        ],
      },
    };
  },
  created() {
  },
  methods: {
    sendCode() {
      const reg = /^1[3456789$]\d{9}/;
       if(this.dataForm.mobile == '' || this.dataForm.mobile == undefined || this.dataForm.mobile == null) {
        this.$message.error("请输入电话号码！")
        return;
      }
      // if(!reg.test(this.dataForm.mobile)) {
      //     this.$message.error("请输入用户名称")
      //     return;
      // }
      this.getVerCode()
      this.countdown = 60;
      this.messageCodeVis = true;
      this.startCountDown();
    },
    startCountDown() {
        const intervalId = setInterval(() =>{
          if(this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(intervalId) 
            this.messageCodeVis = false;
          }
        }, 1000) 
    },
    getVerCode() {
      if(this.dataForm.mobile == '' || this.dataForm.mobile == undefined || this.dataForm.mobile == null) {
        this.$message.error("请输入电话号码！")
        return;
      }
      this.$http({
          url: this.$store.state.httpUrl + "/business/portaluser/getVerCodeFromOa",
          method: "post",
          data: this.$http.adornData({
            mobile: this.dataForm.mobile,
          })
        }).then(({ data }) => {
          if (data && data.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
            });
          }
        });
    },
    // 提交表单
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          let url = "/business/portaluser/login";
          if(this.dataForm.mobile === '123456') {
              url = "/business/portaluser/testlogin";
          }
          this.$http({
            url: this.$store.state.httpUrl + url,
            method: "post",
            data: this.$http.adornData({
              mobile: this.dataForm.mobile,
              password: this.dataForm.password
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              var workNo = data.body.workNo;
              sessionStorage.setItem('workNo', JSON.stringify(workNo))
              sessionStorage.setItem('ATOKEN', JSON.stringify(data.body.token))
              this.$router.replace({ name: "workbench" });
              }
          });
        }
      });
    },
  }
};
</script>

<style lang="scss">
//总页面
html,
body {
  width: 100%;
  height: 50%;
}
.site-wrapper.site-page--login {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("../../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .mid_content {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    margin: auto;
  }

  .site-content__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    padding: 0;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: transparent;
  }
  .el-input__inner {
    height: 49px;
  }
  .login-left {
    width: 457px;
    height: 597px;
    background: rgba(13, 135, 200, 0.73);
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-115%, -50%);
  }
  .login-main {
    width: 639px;
    height: 597px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-14%, -50%);

    text-align: center;
    .el-form-item__error {
      left: 70px;
    }
  }
  .login-title {
    font-size: 2rem;
    color: #2c8cf0;
    font-style: normal;
  }
  .login-captcha {
    overflow: hidden;
    > img {
      width: 180px;
      height: 49px;
      margin-right: 3rem;
      cursor: pointer;
      margin-top: 2px;
    }
  }
  //按钮
  .login-btn-submit {
    width: 60%;
    background-color: #426579;
    margin-top: 0.3rem;
    border: #426579;
  }
}
.en {
  color: #fff;
  font-family: PingFangSC-Light;
  font-size: 22px;
  margin-top: 126px;
  font-weight: 100;
}
.img {
  margin-top: 220px;
}

.container {
  text-align: center;
  margin-top:10%;
}

.second-text {

}
</style>